<script>
import Divider from "@/components/atoms/divider";
import SearchBar from "@/components/molecules/search-bar";
import ButtonNavigation from "@/components/molecules/button-navigation";
import { headerProps } from "@/components/organisms/header/mixin";
import Cart from "@/components/organisms/header/cart/mobile";
import ConnexionRequired from "@/containers/connexion/connexion-required";

export default {
  name: "HeaderStickyMobile",
  components: {
    SearchBar,
    ButtonNavigation,
    Divider,
    Cart,
    ConnexionRequired
  },
  props: {
    ...headerProps()
  },
  emits: ["hideMenu", "showMenu", "showAutosuggest", "setEncartPanierVisible"],
  methods: {
    hideMenu() {
      this.$emit("hideMenu");
    }
  }
};
</script>
<template>
  <transition name="header-sticky">
    <header
      role="banner"
      class="c-header-mobile c-header-mobile--light c-header-mobile--sticky"
    >
      <div class="c-header-mobile__top">
        <ButtonNavigation
          icon-name="hamburger"
          icon-size="md"
          icon-color="primary"
          icon-color-hover="white"
          class="c-header-mobile__button-nav"
          @click="$emit('showMenu')"
        >
          <template #button-content>
            <span class="u-color-primary u-font-12">Menu</span>
          </template>
        </ButtonNavigation>

        <Divider
          vertical
          class="c-header-mobile__divider"
        />

        <SearchBar
          class="c-header-mobile__search-bar"
          toggle-reset-search
          @focus="$emit('showAutosuggest')"
        />
        <Divider
          vertical
          class="c-header-mobile__divider"
        />
        <Cart
          icon-color="primary"
          :total="montantTotalTTC"
          :is-loading="isPanierLoading"
          class="u-ml-sm"
          @click="$emit('setEncartPanierVisible', true)"
        />
      </div>
      <ConnexionRequired />
    </header>
  </transition>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/header-mobile.scss";
</style>
